import { type AuthUser } from "~/api/auth/AuthUser";
import { type AppPermission } from "~/utils/permissions";

export const actionOnMissingAccess = (
  user: AuthUser,
  permission: AppPermission,
  action: () => void,
) => {
  if (!user?.permissions.includes(permission)) {
    action();
  }
};
